// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3tIMO","title":"AfterFrontImage_title__1wrNE"};